import React from 'react';

/**
 * One spec card on the landing page.
 *
 * @param {object} props
 * @param {React.ComponentType} props.icon — @phosphor-icons/react icon component
 *   (Gauge, Fuel, Calendar, Cog, Zap, Droplet, Leaf).
 * @param {string|number} props.value — formatted value to display
 *   (e.g. "150 km", "Hybride", "120 g/km"). Falsy values cause the card
 *   to render `null`.
 */
const SpecCard = ({ icon: Icon, value }) => {
  if (!value && value !== 0) return null;
  return (
    <div className="landing__spec-card">
      <Icon className="landing__spec-icon" weight="light" />
      <span className="landing__spec-value">{value}</span>
    </div>
  );
};

export default React.memo(SpecCard);
